import {executeCrudEpic, Type} from 'lib/crud'
import {dao, name} from 'lib/testType'
import {combineEpics} from 'redux-observable'

export const testTypeEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
)